import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import Panel from "../components/Panel";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

export default function Ratios() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/finance/ratios").then((r) => setData(r.data)); }, []);
    if (!data) return <div className="font-mono-fin text-sm text-[var(--text-secondary)]">// LOADING RATIOS...</div>;

    const categories = [...new Set(data.map((r) => r.category))];

    const STATUS_COLOR = { "good": "#4af6c3", "warning": "#fb8b1e", "bad": "#ff433d" };
    const TrendIcon = ({ trend }) => trend === "up" ? <TrendingUp size={12} /> : trend === "down" ? <TrendingDown size={12} /> : <Minus size={12} />;

    return (
        <div className="space-y-4">
            <div>
                <div className="font-mono-fin text-[10px] uppercase tracking-[0.25em] text-[var(--brand-amber)] mb-1">// FINANCIAL RATIOS WALL</div>
                <h1 className="font-display font-black text-3xl">22 Ratios · One Screen</h1>
                <p className="mt-1 font-mono-fin text-[11px] text-[var(--text-secondary)] uppercase tracking-wider">Live vs Benchmark · Colour-coded exceptions</p>
            </div>

            {categories.map((cat) => (
                <Panel key={cat} testId={`ratio-cat-${cat.toLowerCase()}`} title={cat}>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                        {data.filter((r) => r.category === cat).map((r) => (
                            <div key={r.name} className="border border-panel p-3 hover:bg-[var(--bg-panel-hover)] transition-colors">
                                <div className="text-[10px] font-mono-fin uppercase tracking-[0.1em] text-[var(--text-secondary)]">{r.name}</div>
                                <div className="flex items-baseline gap-1 mt-2">
                                    <span className="font-mono-fin text-2xl text-[var(--text-primary)]">{r.value}</span>
                                    <span className="text-[10px] font-mono-fin text-[var(--text-secondary)]">{r.unit}</span>
                                </div>
                                <div className="flex items-center justify-between mt-2 text-[10px] font-mono-fin uppercase tracking-wider">
                                    <span className="text-[var(--text-muted)]">B: {r.benchmark ?? "—"}{r.unit}</span>
                                    <span className="inline-flex items-center gap-1" style={{ color: STATUS_COLOR[r.status] }}>
                                        <TrendIcon trend={r.trend} />
                                    </span>
                                </div>
                                <div className="h-1 mt-2" style={{ background: STATUS_COLOR[r.status] }} />
                            </div>
                        ))}
                    </div>
                </Panel>
            ))}
        </div>
    );
}
